import React, { FC } from 'react';
import DottedListItem from './DottedListItem/DottedListItem';

interface Props {
  items: Array<string>;
  itemsRegularWeight?: boolean;
}

const DottedList: FC<Props> = ({ items, itemsRegularWeight }) => {
  const itemsMapper = (item: string, index: number) => (
    <DottedListItem key={index} regularWeight={itemsRegularWeight}>
      {item}
    </DottedListItem>
  );

  return <ul>{items.map(itemsMapper)}</ul>;
};

export default DottedList;
